export default {
  "1": { title: "عدد", title_en: "number" },
  "2": { title: "کیلوگرم", title_en: "kilograms" },
  "3": { title: "گرم", title_en: "grams" },
  "4": { title: "بسته", title_en: "boxes" },
  "5": { title: "جعبه", title_en: "boxes" },
  "6": { title: "کارتن", title_en: "boxes" },
  "56": { title: "کیلومتر", title_en: "kilometers" },
  "7": { title: "متر", title_en: "meters" },
  "8": { title: "سانتی‌متر", title_en: "centimeters" },
  "9": { title: "میلی‌متر", title_en: "millimeters" },
  "10": { title: "قطعه", title_en: "Pieces" },
  "11": { title: "متر مربع", title_en: "square meter" },
  "12": { title: "دستگاه", title_en: "devices" },
  "13": { title: "لیتر", title_en: "litter" },
  "14": { title: "جلد", title_en: "volumes" },
  "15": { title: "تن", title_en: "tons" },
  "16": { title: "سی سی", title_en: "cc" },
  "17": { title: "نفر", title_en: "peoples" },
  "18": { title: "تخته", title_en: "boards" },
  "19": { title: "رول", title_en: "rolls" },
  "20": { title: "جفت", title_en: "pairs" },
  "21": { title: "یارد", title_en: "yards" },
  "22": { title: "دسته", title_en: "groups" },
  "23": { title: "شاخه", title_en: "branches" },
  "24": { title: "ست", title_en: "sets" },
  "25": { title: "دسیبل", title_en: "DECIBEL" },
  "64": { title: "نانو‌ثانیه", title_en: "NANO SECOND" },
  "65": { title: "میکرو‌ثانیه", title_en: "MICRO SECOND" },
  "66": { title: "میلی‌ثانیه", title_en: "MILI SECOND" },
  "67": { title: "ثانیه", title_en: "SECOND" },
  "68": { title: "دقیقه", title_en: "MINUTE" },
  "69": { title: "ساعت", title_en: "HOUR" },
  "26": { title: "روز", title_en: "DAY" },
  "27": { title: "هرتز", title_en: "HERTZ" },
  "61": { title: "کیلوهرتز", title_en: "KILO HERTZ" },
  "48": { title: "مگاهرتز", title_en: "MEGA HERTZ" },
  "63": { title: "گیگاهرتز", title_en: "GIGA HERTZ" },
  "28": { title: "بایت", title_en: "BYTE" },
  "57": { title: "کیلوبایت", title_en: "KILO BYTE" },
  "58": { title: "مگابایت", title_en: "MEGA BYTE" },
  "59": { title: "گیگابایت", title_en: "GIGA BYTE" },
  "60": { title: "ترابایت", title_en: "TERA BYTE" },
  "29": { title: "آمپر", title_en: "AMPER" },
  "30": { title: "میلی‌آمپر", title_en: "MILLIAMPEREHOUR" },
  "31": { title: "درصد", title_en: "PERCENT" },
  "32": { title: "صفحه‌بر‌دقیقه", title_en: "PAGEPERMINUTE" },
  "33": { title: "بیت‌ بر‌ثانیه", title_en: "BITPERSEC" },
  "34": { title: "اینچ", title_en: "Inch" },
  "35": { title: "پیکسل", title_en: "PIXEL" },
  "70": { title: "کیلوپیکسل", title_en: "KILO PIXEL" },
  "71": { title: "مگاپیکسل", title_en: "MEGA PIXEL" },
  "72": { title: "گیگاپیکسل", title_en: "GIGA PIXEL" },
  "36": { title: "DPI", title_en: "DPI" },
  "37": { title: "اهم", title_en: "OHM" },
  "38": { title: "ولت", title_en: "VOLT" },
  "39": { title: "CFM", title_en: "CFM" },
  "40": { title: "صفحه", title_en: "PAGES" },
  "41": { title: "صفحه بر ماه", title_en: "PAGEPERMONTH" },
  "42": { title: "بیت", title_en: "BIT" },
  "43": { title: "ساعت", title_en: "HOUR" },
  "44": { title: "هسته", title_en: "CORE" },
  "45": { title: "پین", title_en: "PIN" },
  "46": { title: "پورت", title_en: "PORT" },
  "47": { title: "وات", title_en: "WATT" },
  "49": { title: "وات بر ساعت", title_en: "WATTPERHOUR" },
  "50": { title: "درجه", title_en: "DEGREE" },
  "51": { title: "پیکسل بر اینچ", title_en: "PIXELPERINCH" },
  "52": { title: "بایت بر ثانیه", title_en: "BYTEPERSEC" },
  "74": { title: "کیلوبایت بر ثانیه", title_en: "KILOBYTEPERSEC" },
  "75": { title: "مگابایت بر ثانیه", title_en: "MEGABYTEPERSEC" },
  "76": { title: "گیگابایت بر ثانیه", title_en: "GIGABYTEPERSEC" },
  "77": { title: "ترابایت بر ثانیه", title_en: "TERABYTEPERSEC" },
  "53": { title: "رکورد", title_en: "RECORD" },
  "54": { title: "دور بر دقیقه", title_en: "RPM" },
  "55": { title: "لومن", title_en: "LUMEN" },
  "73": { title: "درجه سانتی‌گراد", title_en: "Degrees Celsius" },
};
